import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "form"
};
const _hoisted_2 = {
  key: 0,
  class: "text-center"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { computed, ref, watch } from "vue";
import SendMsg from "@/components/UpdateUserProfileSendEmailMsg.vue";
import { ElMessage } from "element-plus";
import { httpPost } from "@/utils/http";
import { checkSession } from "@/store/cache";
export default {
  __name: 'BindEmail',
  props: {
    oldEmail: String,
    show: Boolean
  },
  emits: ['hide'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });
    const title = ref('绑定邮箱');
    const email = ref('');
    const form = ref({
      email: '',
      code: ''
    });
    watch(showDialog, val => {
      if (val) {
        form.value.code = '';
        form.value.email = '';
        checkSession().then(user => {
          email.value = user.email;
        });
      }
    });
    const emits = __emit;
    const save = () => {
      if (form.value.code === '') {
        return ElMessage.error("请输入验证码");
      }
      httpPost('/api/user/bind/email', form.value).then(() => {
        ElMessage.success("绑定成功");
        emits('hide');
      }).catch(e => {
        ElMessage.error("绑定失败：" + e.message);
      });
    };
    const close = function () {
      emits('hide');
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        style: {
          "max-width": "400px"
        },
        onClose: close,
        title: title.value
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 提交绑定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.oldEmail !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, "当前已绑定邮箱：" + _toDisplayString(__props.oldEmail), 1)) : _createCommentVNode("", true), _createVNode(_component_el_form, {
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "邮箱地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.email = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "验证码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              gutter: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 16
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.code = $event),
                  maxlength: "6"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8,
                style: {
                  "padding-left": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(SendMsg, {
                  receiver: form.value.email,
                  type: "email"
                }, null, 8, ["receiver"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};